import { PromoPhase } from '../use-ai-promo';
import { Badge, VStack } from 'components';
import { Button, Dialog, Text } from 'components/ui';

import { AiPromoActions } from './ai-promo-actions';
import { AiPromoSkeleton } from './ai-promo-skeleton';

type AiPromoContentProps = {
  dialogTitle: string;
  phase: PromoPhase;
  onClose: () => void;
  onSubmit: () => void;
  handleRetry?: () => void;
};

export const AiPromoContent = (props: AiPromoContentProps) => {
  const { dialogTitle, phase, onClose, onSubmit, handleRetry } = props;
  const isErrorStatus = phase.status === 'check-error';

  if (phase.status === 'checking') {
    return <AiPromoSkeleton />;
  }

  return (
    <>
      <VStack spacing="xs">
        <Dialog.Title>{dialogTitle}</Dialog.Title>
        {!isErrorStatus && (
          <Badge icon="AiGenerate" shape="square">
            Новая функция
          </Badge>
        )}
      </VStack>

      {!isErrorStatus ? (
        <>
          <VStack spacing="base">
            {(phase.text ?? '').split('\n').map((line, i) => (
              <Text key={i}>{line}</Text>
            ))}
          </VStack>

          <AiPromoActions phase={phase} onClose={onClose} onSubmit={onSubmit} />
        </>
      ) : (
        <VStack
          spacing="xxs"
          align="center"
          justify="center"
          style={{ minHeight: 176 }}
        >
          <Text color="gray.400">
            Что-то пошло не так. Запросите данные ещё раз
          </Text>
          <Text color="gray.400">
            Если ошибка повторяется — напишите в техническую поддержку
          </Text>

          <Button mode="accent" variant="ghost" size="s" onClick={handleRetry}>
            Запросить повторно
          </Button>
        </VStack>
      )}
    </>
  );
};
